// extracted by mini-css-extract-plugin
export default {"main":"NewCommission_main__JX84-","title":"NewCommission_title__Rf9eg"};